// For full API documentation, including code examples, visit https://wix.to/94BuAAs
import wixLocation from 'wix-location';


$w.onReady(function () {
	//TODO: write your page related code here...

});

export function column6_mouseOut(event) {
	//Add your code for this event here:
	
 
}

export function column6_click(event) {
	//<a href="www.chuckscd.com">
	wixLocation.to("https://chuckscd.wordpress.com/");
	//$w('#columnStrip1').onClick(event)

}

export function column5_click(event) {
	//Add your code for this event here: 
	wixLocation.to("https://chucks85th.wordpress.com");
}

export function column5_click_1(event) {
	//Add your code for this event here: 
	wixLocation.to("https://chucks85th.wordpress.com");
}


export function column5_mouseIn(event) {
	//Add your code for this event here:
	//$w('#column5').//background.src = 'wix:image://v1/6213f4_44d58a9b512d498d978441f86c616631~mv2.jpg/Screenshot_edited.jpg#originWidth=1490&originHeight=1125' 
}

export function column5_mouseOut(event) {
	//Add your code for this event here: 
}